<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BuzzInsightMetricRow from './BuzzInsightMetricRow.vue';

const props = defineProps({
  reviews: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const metrics = computed(() => {
  const items = [];
  if (props.reviews?.rating != null) {
    items.push({
      key: 'rating',
      label: t('BUZZ_REPORTS.INSIGHTS.GOOGLE_RATING'),
      value: Number(props.reviews.rating).toFixed(1),
      infoText: t('BUZZ_REPORTS.INSIGHTS.GOOGLE_RATING'),
    });
  }
  if (props.reviews?.review_count != null) {
    items.push({
      key: 'reviews',
      label: t('BUZZ_REPORTS.INSIGHTS.REVIEW_COUNT'),
      value: String(props.reviews.review_count),
      infoText: t('BUZZ_REPORTS.INSIGHTS.REVIEW_COUNT'),
    });
  }
  return items;
});
</script>

<template>
  <BuzzInsightMetricRow
    :metrics="metrics"
    :empty-label="t('BUZZ_REPORTS.INSIGHTS.NO_REVIEWS')"
  />
</template>
